<template>
  <div class="_content">
    <iframe width="100%" height="100%" frameborder="0" :src="url"></iframe>
    <!-- 添加关闭按钮 -->
    <button class="close-btn" @click="handleClose">×</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: tuhu.getParam('url')
    }
  },
  methods: {
    handleClose() {
     tuhu.navigateBack()
    }
  }
}
</script>

<style scoped>
/* 关闭按钮样式 */
.close-btn {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 30px;
  height: 30px;
  background: #333;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 1003;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.close-btn:hover {
  background: #ff0000;
  transform: scale(1.1);
}

._content {
  position: relative; /* 确保绝对定位的按钮相对于此容器定位 */
  width: 100%;
  height: 100%;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/pages/common/review.vue